<template>

    <article>

        <div v-if="showPopup" class="popup">

            <header class="popup__a__header">

                <a class="popup__a__cancel-container" @click="next">

                    <img class="popup__a__cancel-btn" src="/img/icons/cancel-white.svg">

                </a>

            </header>

            <section class="popup__a__section">

                <h1 class="cf-title-2 popup__a__title">{{ $t('download_app_download_app') }}</h1>

                <p class="cf-text popup__b__text">{{ computedFirstText }}</p>

                <p class="cf-text popup__b__text">{{ computedSecondText }}</p>

            </section>

            <img :class="{ 'img-relative': minimalHeight }" class="popup__phone" src="/img/phone/apple-i-phone-xs-silver@3x.png">

            <footer class="popup__footer">

                <button class="btn btn-green btn-big popup__footer-btn" @click="downloadApp">{{ $t('download_app_download_mobile_app') }}</button>

            </footer>

        </div>

    </article>

</template>

<script>
import Tag from '@/modules/tag'
import Tracking from '@/modules/tracking'
import UserAgent from '@/modules/userAgent'
import Markdown from '@/components/Markdown'
import Firebase from '@/modules/firebase'

export default {
    name: 'block-mobile-popup',

    components: {Markdown},

    props: {
        provider: {
            type: String,
            default: ''
        }
    },

    watch: {
        provider: function () {
            this.init()
        }
    },

    computed: {

        computedFirstText: function () {

            return this.$t(`download_app_blocking_impossible_to_connect_${this.provider}_1`)
        },

        computedSecondText: function () {

            return this.$t(`download_app_blocking_impossible_to_connect_${this.provider}_2`)
        }
    },

    data() {
        return {
            showPopup: false,
            versionAppBlocking: false,
            versionApp: false,
            minimalHeight: window.screen.height < 627,
            isIos: false
        }
    },
    mounted() {
        this.init()
    },
    methods: {
        init() {
            Firebase.getValue('login_google_without_webview', 'Boolean')
                .then(loginGoogleWithoutWebview => {

                    if ((this.provider === 'outlook' || this.provider === 'google') && this.$mq !== 'lg' && !loginGoogleWithoutWebview) {

                        this.isIos = UserAgent.is.ios()
                        Tag.pageViewAmplitude(this, 'download_app', this.provider)
                        this.versionApp = true
                        this.showPopup = true

                    } else {
                        this.clearTheWay()
                    }
                })
                .catch(() => {
                    this.clearTheWay()
                })
        },
        downloadApp() {
            Tag.clickAmplitude(this, 'download', this.provider)
            this.isIos ? this.downloadIos() : this.downloadAndroid()
            this.clearTheWay()
        },
        close() {
            this.$router.push({path: '/'})
        },
        clearTheWay() {
            this.$emit('unblock')
        },
        next() {
            this.showPopup = false
            this.clearTheWay()
        },
        popupTracking() {
            return this.versionAppBlocking ? 'download_app_blocking' : 'download_app'
        },
        downloadAndroid() {

            const array = []

            const referrer = Tracking.getTracking().referrer
            const utmCampaign = Tracking.getTracking().utm_campaign
            const utmMedium = Tracking.getTracking().utm_source
            const utmSource = this.popupTracking()

            if (referrer) {
                array.push('referrer=' + referrer)
            }
            if (utmCampaign) {
                array.push('utm_campaign=' + utmCampaign)
            }
            if (utmMedium) {
                array.push('utm_medium=' + utmMedium)
            }
            if (utmSource) {
                array.push('utm_source=' + utmSource)
            }

            const utms = encodeURIComponent(array.join('&'))

            const url = `https://play.google.com/store/apps/details?id=io.cleanfox.android&referrer=${utms}`

            window.open(url)
        },
        downloadIos() {
            const tracker = this.popupTracking() === 'download_app_blocking' ? 'z8qb9sg' : 'vtxs48x'
            const url = `https://app.adjust.com/${tracker}?campaign=${Tracking.getTracking().utm_campaign || ''}&adgroup=${Tracking.getTracking().referrer || ''}&creative=${Tracking.getTracking().utm_source || ''}`
            window.open(url)
        }
    }
}
</script>

<style lang="scss" scoped>
.popup {
    background-color: $aquamarine;
    background-image: url('/img/background/fetch-mobile.svg');
    background-repeat: no-repeat;
    background-position: bottom;
    background-size: cover;
    padding: 8px 8px 0;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
    color: $white;
    display: flex;
    flex-direction: column;
    align-items: center;

    &__phone {
        position: fixed;
        width: 279px;
        bottom: -226px;
    }

    &__footer {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        width: 100%;
        height: 88px;
        background-color: $white;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    &__footer-btn {
        max-width: 238px;
    }

    &__a {
        &__section-top {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
        }

        &__header {
            width: 100%;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: flex-end;
        }

        &__cancel-container {
            width: 40px;
            height: 40px;
            display: flex;
            justify-content: center;
            align-items: center;
        }

        &__cancel-btn {
            width: 24px;
            object-fit: contain;
        }

        &__section {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;
            padding: 0 24px;
        }

        &__img {
            width: 80px;
            object-fit: contain;
        }

        &__title {
            margin: 0;
        }

        &__text-container {
            display: flex;
            align-items: center;
            margin-bottom: 8px;
        }

        &__text-icon {
            width: 18px;
            object-fit: contain;
            margin-right: 4px;
        }

        &__text {
            font-size: 14px;
            line-height: 1.29;
        }
    }

    &__b {
        &__section {
            padding: 32px 16px 0;
        }

        &__title {
            text-align: left;
        }

        &__text {
            text-align: left;
            margin-top: 8px;
        }

        &__signature {
            text-align: right;
            margin-top: 8px;
        }
    }

    .img-relative {
        position: relative;
        bottom: 0;
        margin-top: 32px;
    }
}
</style>
